import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enTranslations from './components/Middlewares/locale/enTranslation';
import esTranslations from './components/Middlewares/locale/esTranslation';

// the translations
const resources = {
    EN: {
        translation: { ...enTranslations }
    },
    ES: {
        translation: { ...esTranslations }
    }
};

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: "ES",

        keySeparator: false, // we do not use keys in form messages.welcome

        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;